const { parsePhoneNumber, AsYouType, isValidPhoneNumber } = require('libphonenumber-js/max')

export const HANGUPCAUSES_MAPPER = {
  // Custom SipPulse
  // TODO - Alterar NUMBER_CHANGED para Número mudou e descomentar VOICEMAIL_PRE e VOICEMAIL_POST
  NUMBER_CHANGED: 'Caixa postal',
  // VOICEMAIL_PRE: 'Caixa postal',
  // VOICEMAIL_POST: 'Caixa postal IOS',
  // Answered
  NORMAL_CLEARING: 'Atendida',
  CALL_AWARDED_DELIVERED: 'Atendida',
  PICKED_OFF: 'Atendida',
  // Not answered
  NORMAL_UNSPECIFIED: 'Temporariamente indisponível',
  LOSE_RACE: 'Corrida perdida',
  NO_ANSWER: 'Não atendida',
  NO_USER_RESPONSE: 'Não atendida',
  USER_BUSY: 'Ocupado',
  CALL_REJECTED: 'Rejeitada',
  FACILITY_REJECTED: 'Rejeitada',
  DESTINATION_OUT_OF_ORDER: 'Fora de área',
  SUBSCRIBER_ABSENT: 'Fora de área',
  ORIGINATOR_CANCEL: 'Cancelada',
  INCOMING_CALL_BARRED: 'Barrada',
  OUTGOING_CALL_BARRED: 'Barrada',
  // Redirected
  ATTENDED_TRANSFER: 'Redirecionada',
  BLIND_TRANSFER: 'Redirecionada',
  REDIRECTION_TO_NEW_DESTINATION: 'Redirecionada',
  USER_CHALLENGE: 'Redirecionada',
  // Not found
  UNALLOCATED_NUMBER: 'Número não encontrado',
  USER_NOT_REGISTERED: 'Número não encontrado',
  // Error
  ACCESS_INFO_DISCARDED: 'Não foi possível completar',
  ALLOTTED_TIMEOUT: 'Não foi possível completar',
  BEARERCAPABILITY_NOTAUTH: 'Não foi possível completar',
  BEARERCAPABILITY_NOTAVAIL: 'Não foi possível completar',
  BEARERCAPABILITY_NOTIMPL: 'Não foi possível completar',
  CHAN_NOT_IMPLEMENTED: 'Não foi possível completar',
  CHANNEL_UNACCEPTABLE: 'Não foi possível completar',
  CRASH: 'Não foi possível completar',
  EXCHANGE_ROUTING_ERROR: 'Não foi possível completar',
  IE_NONEXIST: 'Não foi possível completar',
  INCOMPATIBLE_DESTINATION: 'Não foi possível completar',
  INTERWORKING: 'Não foi possível completar',
  INVALID_CALL_REFERENCE: 'Não foi possível completar',
  INVALID_IE_CONTENTS: 'Não foi possível completar',
  INVALID_MSG_UNSPECIFIED: 'Não foi possível completar',
  INVALID_NUMBER_FORMAT: 'Não foi possível completar',
  FACILITY_NOT_IMPLEMENTED: 'Não foi possível completar',
  FACILITY_NOT_SUBSCRIBED: 'Não foi possível completar',
  GATEWAY_DOWN: 'Não foi possível completar',
  MANAGER_REQUEST: 'Não foi possível completar',
  MANDATORY_IE_LENGTH_ERROR: 'Não foi possível completar',
  MANDATORY_IE_MISSING: 'Não foi possível completar',
  MEDIA_TIMEOUT: 'Não foi possível completar',
  MESSAGE_TYPE_NONEXIST: 'Não foi possível completar',
  NETWORK_OUT_OF_ORDER: 'Não foi possível completar',
  NO_ROUTE_TRANSIT_NET: 'Não foi possível completar',
  NO_ROUTE_DESTINATION: 'Não foi possível completar',
  NORMAL_CIRCUIT_CONGESTION: 'Não foi possível completar',
  NORMAL_TEMPORARY_FAILURE: 'Não foi possível completar',
  PRE_EMPTED: 'Não foi possível completar',
  PROGRESS_TIMEOUT: 'Não foi possível completar',
  PROTOCOL_ERROR: 'Não foi possível completar',
  RECOVERY_ON_TIMER_EXPIRE: 'Não foi possível completar',
  REQUESTED_CHAN_UNAVAIL: 'Não foi possível completar',
  RESPONSE_TO_STATUS_ENQUIRY: 'Não foi possível completar',
  SERVICE_NOT_IMPLEMENTED: 'Não foi possível completar',
  SERVICE_UNAVAILABLE: 'Não foi possível completar',
  SYSTEM_SHUTDOWN: 'Não foi possível completar',
  SWITCH_CONGESTION: 'Não foi possível completar',
  WRONG_CALL_STATE: 'Não foi possível completar',
  WRONG_MESSAGE: 'Não foi possível completar'
}

export const HANGUPCAUSES_CODES = {
  UNSPECIFIED: '0',
  UNALLOCATED_NUMBER: '1',
  NO_ROUTE_TRANSIT_NET: '2',
  NO_ROUTE_DESTINATION: '3',
  CHANNEL_UNACCEPTABLE: '6',
  CALL_AWARDED_DELIVERED: '7',
  NORMAL_CLEARING: '16',
  USER_BUSY: '17',
  NO_USER_RESPONSE: '18',
  NO_ANSWER: '19',
  SUBSCRIBER_ABSENT: '20',
  CALL_REJECTED: '21',
  NUMBER_CHANGED: '22',
  VOICEMAIL_PRE: '410',
  VOICEMAIL_POST: '411',
  REDIRECTION_TO_NEW_DESTINATION: '23',
  EXCHANGE_ROUTING_ERROR: '25',
  DESTINATION_OUT_OF_ORDER: '27',
  INVALID_NUMBER_FORMAT: '28',
  FACILITY_REJECTED: '29',
  RESPONSE_TO_STATUS_ENQUIRY: '30',
  NORMAL_UNSPECIFIED: '31',
  NORMAL_CIRCUIT_CONGESTION: '34',
  NETWORK_OUT_OF_ORDER: '38',
  NORMAL_TEMPORARY_FAILURE: '41',
  SWITCH_CONGESTION: '42',
  ACCESS_INFO_DISCARDED: '43',
  REQUESTED_CHAN_UNAVAIL: '44',
  PRE_EMPTED: '45',
  FACILITY_NOT_SUBSCRIBED: '50',
  OUTGOING_CALL_BARRED: '52',
  INCOMING_CALL_BARRED: '54',
  BEARERCAPABILITY_NOTAUTH: '57',
  BEARERCAPABILITY_NOTAVAIL: '58',
  SERVICE_UNAVAILABLE: '63',
  BEARERCAPABILITY_NOTIMPL: '65',
  CHAN_NOT_IMPLEMENTED: '66',
  FACILITY_NOT_IMPLEMENTED: '69',
  SERVICE_NOT_IMPLEMENTED: '79',
  INVALID_CALL_REFERENCE: '81',
  INCOMPATIBLE_DESTINATION: '88',
  INVALID_MSG_UNSPECIFIED: '95',
  MANDATORY_IE_MISSING: '96',
  MESSAGE_TYPE_NONEXIST: '97',
  WRONG_MESSAGE: '98',
  IE_NONEXIST: '99',
  INVALID_IE_CONTENTS: '100',
  WRONG_CALL_STATE: '101',
  RECOVERY_ON_TIMER_EXPIRE: '102',
  MANDATORY_IE_LENGTH_ERROR: '103',
  PROTOCOL_ERROR: '111',
  INTERWORKING: '127',
  ORIGINATOR_CANCEL: '487',
  CRASH: '500',
  SYSTEM_SHUTDOWN: '501',
  LOSE_RACE: '502',
  MANAGER_REQUEST: '503',
  BLIND_TRANSFER: '600',
  ATTENDED_TRANSFER: '601',
  ALLOTTED_TIMEOUT: '602',
  USER_CHALLENGE: '603',
  MEDIA_TIMEOUT: '604',
  PICKED_OFF: '605',
  USER_NOT_REGISTERED: '606',
  PROGRESS_TIMEOUT: '607',
  GATEWAY_DOWN: '609'
}

export function validatePhone (phone) {
  if (phone) {
    let validatedPhone = sanitizePhone(phone)
    validatedPhone = convertFromPbx(validatedPhone)
    validatedPhone = addMissingBrazilCountryCode(validatedPhone)
    validatedPhone = addMissingNinthDigit(validatedPhone)
    try {
      const phoneNumber = parsePhoneNumber(validatedPhone)
      if (phoneNumber && phoneNumber.isValid()) {
        const response = {
          received: phone,
          number: phoneNumber.number,
          country: phoneNumber.country,
          type: phoneNumber.getType(),
          nationalNumber: phoneNumber.nationalNumber
        }
        if (phoneNumber.country === 'BR') {
          response.formatted = phoneNumber.formatNational()
        } else {
          response.formatted = phoneNumber.formatInternational()
        }
        return response
      } else {
        return phone
      }
    } catch (_) {
      return phone
    }
  }
}

export function convertToPbx (phone) {
  if (phone.country === 'BR') {
    if (['TOLL_FREE', 'SHARED_COST'].includes(phone.type)) {
      return `00${phone.number.replace('+55', '')}`
    } else {
      return `0${phone.number.replace('+55', '')}`
    }
  } else {
    return `000${phone.number.replace('+', '')}`
  }
}

export function phoneDigitsOnly (value) {
  if (value == null || value === '') return ''
  return String(value).replace(/\D/g, '').slice(0, 11)
}

export function phoneToNationalDisplay (value) {
  if (value == null || value === '') return ''
  const digits = String(value).replace(/\D/g, '')
  if (!digits) return ''
  let national = digits
  if (national.startsWith('55') && national.length > 11) {
    national = national.slice(2)
  }
  return national.slice(0, 11)
}

export function allowOnlyNumericKeydown (event) {
  if (event.ctrlKey || event.metaKey) return
  if (/^\d$/.test(event.key)) return
  if (['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return
  event.preventDefault()
}

export function formatPhoneMask (digits) {
  if (!digits) return ''
  const digitsOnly = phoneDigitsOnly(digits)
  if (!digitsOnly) return ''
  return new AsYouType('BR').input(digitsOnly)
}

export function isValidPhone (value) {
  return isValidPhoneNumber(phoneDigitsOnly(value), 'BR')
}

export function maskNationalPhone (value) {
  return formatPhoneMask(phoneToNationalDisplay(value))
}

function sanitizePhone (phone) {
  return String(phone).replace(/[^0-9+]/g, '')
}

function convertFromPbx (phone) {
  if (phone.startsWith('000')) {
    return phone.replace(/^000/, '+')
  } else if (phone.startsWith('00')) {
    return phone.replace(/^00/, '+55')
  } else if (phone.startsWith('0')) {
    return phone.replace(/^0/, '+55')
  } else {
    return phone
  }
}

function addMissingBrazilCountryCode (phone) {
  if (!phone.startsWith('+')) {
    if (phone.length === 12 || phone.length === 13) {
      return `+${phone}`
    } else if (phone.length === 10 || phone.length === 11) {
      return `+55${phone}`
    }
  }
  return phone
}

function addMissingNinthDigit (phone) {
  if (phone.startsWith('+55') && phone.length === 13) {
    const regexNinthDigit = /^((?:\+?[0-9]{2})?[-\s.]?[(]?[0-9]{2}[)]?[-\s.]?)([6-9]{1}[0-9]{3}[-\s.]?[0-9]{4})$/
    const numberWithoutNinthDigit = regexNinthDigit.exec(phone)
    if (numberWithoutNinthDigit && numberWithoutNinthDigit.length >= 3) {
      return `${numberWithoutNinthDigit[1]}9${numberWithoutNinthDigit[2]}`
    }
  }
  return phone
}



// WEBPACK FOOTER //
// ./src/utils/phone.js